export const THROW_DATE_ERROR_MESSAGE = 'No valid date object provided!'
export const THROW_INTERVAL_ERROR_MESSAGE = 'No valid interval provided!'
export const THROW_INTL_ERROR_MESSAGE = 'No valid intl object provided!'
export const THROW_NOT_AN_ARRAY_ERROR_MESSAGE = 'No valid array provided!'
